import React from 'react';
import {riskTypeIdentifiers} from "../../../routes";
import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {getInactiveUsers} from "../../../services/shared/InactiveUsers";
import {getPanelLink, usersFromQuery} from "../DashboardPanels/panelCommon";
import {DonutDriftChart} from "./DonutDriftChart";
import {DefaultContainer} from "../../../components/common/DefaultContainer";
import {saasCoverageCount} from "../../../utils/saasUtils";
import {getEnabledUsersCount} from "../../../services/shared/EnabledUsers";
import {getInactiveUserDailyDrifts} from "../../../services/DriftService/DailyDriftService";
import {countInactiveDrift} from "../../../components/DriftGraph/DailyDriftDataCounters";

export const InactiveUserChart = () => {
  const allUsersQuery = useQueryWithAccessToken({
    queryKey: [cacheKeys.allEnabledUsersCount],
    queryFunction: getEnabledUsersCount,
    queryFunctionVariables:{}
  }
  );

  const {isLoading: isInactiveLoading, data: inactiveDrifts, isError: isInactiveError} = useQueryWithAccessToken({
    queryKey: [cacheKeys.dailyDrifts.inactiveUsers],
    queryFunction: getInactiveUserDailyDrifts,
    queryFunctionVariables:{},
    }
  );

  const fullQuery = useQueryWithAccessToken({
    queryKey: [cacheKeys.inactiveUsers],
    queryFunction: getInactiveUsers,
    queryFunctionVariables:{}}
  );

  const {isLoading: isCurrentStateLoading, count, users, isError: isCurrentStateError} = usersFromQuery(fullQuery);

  // The panel has errored if any of the queries have errored
  let isError = allUsersQuery.isError || isInactiveError || isCurrentStateError;

  // The panel is loading if any of the queries are loading
  let isLoading = allUsersQuery.isLoading || isInactiveLoading || isCurrentStateLoading;


  const theSaasCoverageCount = saasCoverageCount(users);

  let inactiveSeries = [{
    name: "Inactive",
    color: "#82ca9d",
    start: count,
    data: inactiveDrifts,
    countFn : countInactiveDrift
  }];

  return (<DefaultContainer
    sx={{
      display: 'flex',
      marginBottom: 0,
      maxWidth: '49%',
      minWidth: '49%',
    }}
  >
    <DonutDriftChart
      title={"Inactive Users"}
      count={count}
      outOf={allUsersQuery.data}
      appCount={theSaasCoverageCount}
      description={<span><em>Users for which Detexian has detected <strong>no activity for 60 days</strong></em></span>}
      driftSeries={inactiveSeries}
      isLoading={isLoading}
      isError={isError}
      viewAllUrl={getPanelLink(riskTypeIdentifiers.inactive, count)}/>
  </DefaultContainer>)
};
